import { __classPrivateFieldSet, __classPrivateFieldGet } from '../../external_node_modules/tslib/tslib.es6.js';
import { PLATFORMS } from '../../constants/platforms.js';

var _UserEntity_platform, _UserEntity_platformCountry, _UserEntity_spaCountry, _UserEntity_userId, _UserEntity_platformUserId, _UserEntity_isPurchaseDisabled, _UserEntity_isAccountUncompleted, _UserEntity_billingAddress, _UserEntity_regional;
class UserEntity {
    constructor(spaCountry, platformCountry, userId, platform, isAccountUncompleted, billingAddress, regional) {
        _UserEntity_platform.set(this, void 0);
        _UserEntity_platformCountry.set(this, void 0);
        _UserEntity_spaCountry.set(this, void 0);
        _UserEntity_userId.set(this, null);
        _UserEntity_platformUserId.set(this, null);
        _UserEntity_isPurchaseDisabled.set(this, false);
        _UserEntity_isAccountUncompleted.set(this, null);
        _UserEntity_billingAddress.set(this, null);
        _UserEntity_regional.set(this, null);
        __classPrivateFieldSet(this, _UserEntity_platform, platform, "f");
        __classPrivateFieldSet(this, _UserEntity_platformCountry, platformCountry, "f");
        __classPrivateFieldSet(this, _UserEntity_spaCountry, spaCountry, "f");
        __classPrivateFieldSet(this, _UserEntity_userId, userId, "f");
        __classPrivateFieldSet(this, _UserEntity_isAccountUncompleted, isAccountUncompleted, "f");
        __classPrivateFieldSet(this, _UserEntity_billingAddress, billingAddress, "f");
        __classPrivateFieldSet(this, _UserEntity_regional, regional, "f");
    }
    get canPurchase() {
        if (__classPrivateFieldGet(this, _UserEntity_isPurchaseDisabled, "f")) {
            return false;
        }
        return this.spaCountry ? this.spaCountry === this.platformCountry : true;
    }
    get isLoggedIn() {
        return !!__classPrivateFieldGet(this, _UserEntity_userId, "f");
    }
    get spaCountry() {
        return __classPrivateFieldGet(this, _UserEntity_spaCountry, "f");
    }
    get platformCountry() {
        if ([PLATFORMS.STEAM, PLATFORMS.WIN_STORE].includes(__classPrivateFieldGet(this, _UserEntity_platform, "f"))) {
            return __classPrivateFieldGet(this, _UserEntity_platformCountry, "f");
        }
        return this.spaCountry;
    }
    get userId() {
        return __classPrivateFieldGet(this, _UserEntity_userId, "f");
    }
    get platformUserId() {
        return __classPrivateFieldGet(this, _UserEntity_platformUserId, "f");
    }
    get isAccountUncompleted() {
        return __classPrivateFieldGet(this, _UserEntity_isAccountUncompleted, "f");
    }
    get userPlatform() {
        return __classPrivateFieldGet(this, _UserEntity_platform, "f");
    }
    get billingAddress() {
        if (__classPrivateFieldGet(this, _UserEntity_platform, "f") === PLATFORMS.WEB) {
            return __classPrivateFieldGet(this, _UserEntity_billingAddress, "f");
        }
        return null;
    }
    get regional() {
        return __classPrivateFieldGet(this, _UserEntity_regional, "f");
    }
    setPlatformUserId(platformUserId) {
        __classPrivateFieldSet(this, _UserEntity_platformUserId, platformUserId, "f");
    }
    disableUserPurchase() {
        __classPrivateFieldSet(this, _UserEntity_isPurchaseDisabled, true, "f");
    }
}
_UserEntity_platform = new WeakMap(), _UserEntity_platformCountry = new WeakMap(), _UserEntity_spaCountry = new WeakMap(), _UserEntity_userId = new WeakMap(), _UserEntity_platformUserId = new WeakMap(), _UserEntity_isPurchaseDisabled = new WeakMap(), _UserEntity_isAccountUncompleted = new WeakMap(), _UserEntity_billingAddress = new WeakMap(), _UserEntity_regional = new WeakMap();

export { UserEntity };
//# sourceMappingURL=user.entity.js.map
